import React from "react";

import LoadingDots from "components/LoadingDots";

import classes from "./style.module.scss";

const typeClasses = (type) =>
    ({
        hollow: classes.hollow,
        red: classes.red,
        white: classes.white,
        highlight: classes.highlight,
        emptyBg: classes.emptyBg,
        slate: classes.slate,
        lightGrey: classes.lightGrey,
        green: classes.green,
        orange: classes.orange,
        default: "",
    })[type || "default"];

export default React.memo(
    ({
        children,
        type = "",
        onClick,
        disabled = false,
        loading = false,
        large = false,
        small = false,
        className,
        smallPadding = false,
        icon: Icon,
        style = {},
        ...props
    }) => (
        <button
            style={{ ...style, opacity: disabled && !loading ? 0.7 : 1 }}
            className={`${classes.button} ${type ? typeClasses(type) : ""} ${large ? classes.large : ""} ${
                small ? classes.small : ""
            } ${className ? className : ""} ${Icon ? classes.hasIcon : ""} ${children ? classes.hasChildren : ""} ${
                smallPadding ? classes.smallPadding : ""
            } ${loading ? classes.loading : ""}`}
            onClick={onClick}
            disabled={disabled || loading}
            aria-busy={loading}
            {...props}
        >
            <span>
                {loading ? (
                    <LoadingDots small color="currentColor" />
                ) : (
                    <>
                        {Icon && <Icon />} {children}
                    </>
                )}
            </span>
        </button>
    )
);
